import React from "react";
import { Route } from "react-router-dom";

import { CalculateMaterial, CalculateMaterialAccess } from "../pages/ERP/reports/calculate-material";
import { SalesHistory, SalesHistoryAccess } from "../pages/ERP/reports/sales-history";
import { StockSummary, StockSummaryAccess } from "../pages/ERP/reports/stock-summary";
import { SizeWeight, SizeWeightAccess } from "../pages/ERP/reports/size-weight";
import { MaterialUsage, MaterialUsageAccess } from "../pages/ERP/reports/material-usage";
import { PoPending, PoPendingAccess } from "../pages/ERP/reports/po-pending";

export const ERPReportRouter = (
  <>
    <Route path="/ERP/calculate-material/" exact element={<CalculateMaterial />}>
      <Route index element={<CalculateMaterialAccess />} />
    </Route>
    <Route path="/ERP/material-usage/" exact element={<MaterialUsage />}>
      <Route index element={<MaterialUsageAccess />} />
    </Route>
    <Route path="/ERP/sales-history/" exact element={<SalesHistory />}>
      <Route index element={<SalesHistoryAccess />} />
    </Route>
    <Route path="/ERP/stock-summary/" exact element={<StockSummary />}>
      <Route index element={<StockSummaryAccess />} />
    </Route>
    <Route path="/ERP/po-pending/" exact element={<PoPending />}>
      <Route index element={<PoPendingAccess />} />
    </Route>
    <Route path="/ERP/size-weight/" exact element={<SizeWeight />}>
      <Route index element={<SizeWeightAccess />} />
    </Route>
  </>
);

